import enCompanyFeedbacks from './en';
import ruCompanyFeedbacks from './ru';

export default {
  en: {
    ...enCompanyFeedbacks,
  },
  ru: {
    ...ruCompanyFeedbacks,
  },
};
